<template lang="pug">
.container-restricao.row
    .col-12
        small Foram detectadas as seguintes irregularidades:

        .list-group
            a.list-group-item.list-group-item-action
                .row.text-left
                    label.col-3 Ano da ação fiscal

                    label.col-3 CPF/CNPJ

                    label.col-2 CNAE

                    label.col-3 Estabelecimento

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in trabalhoEscravo.restricoes'
            )
                .row.text-left
                    .col-3
                        span {{ restricao.properties.ano_acao_fiscal }}

                    .col-3
                        span {{ numeralStringFormatTocpfCnpj(restricao.properties.cpf_cnpj) }}

                    .col-2.pr-0
                        span {{ restricao.properties.cnae }}

                    .col-3.pr-0
                        .text-wrap(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            :title='restricao.properties.estabelecimento'
                        ) {{ restricao.properties.estabelecimento }}
</template>

<script>
import Formatters from '../../../utils/formatters';

export default {
    name: 'TrabalhoEscravo',

    props: {
        trabalhoEscravo: {
            type: Object,
            required: true
        }
    },

    mounted() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
        });
    },

    methods: {
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return Formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        }
    }
};
</script>
